import { render } from "./SidebarMenuItemBot2.vue?vue&type=template&id=0e194c83&scoped=true"
import script from "./SidebarMenuItemBot2.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot2.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot2.vue?vue&type=style&index=0&id=0e194c83&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e194c83"]])

export default __exports__